import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

const adminOnlyRoutes = [
  '/AppReport',
  '/eventReport',
  '/touchesReport',
  '/siteReport',
  '/anniversaryReport',
  '/user-management',
  '/dashboard',
  '/user',
  '/site-management',
  '/siteDetails',
  '/emailTemplate',
  '/emailDetails', // Contains email ID.
  '/emailNewTemplate'
];

const getReturnRouteForCurrentUser = (userRole, currentRoute) => {
  if (userRole === 'Admin') {
    return currentRoute;
  }

  if (adminOnlyRoutes.some(adminRoute => currentRoute.includes(adminRoute))) {
    switch (userRole) {
      case 'Visit Requester':
      case 'Requester':
        return '/AppRequester';
      case 'MLTUser':
      case 'MLTCoordinator':
        return '/AppMltEvent';
      case 'Family':
      case 'FamilyCoordinator':
        return '/AppFamily';
      default:
        return '/';
    }
  }

  return currentRoute;
};

const PrivateRoute = () => {
  const { accounts } = useMsal();
  const location = useLocation();
  const role = localStorage.getItem('role');

  if (accounts.length > 0 && role) {
    const navigateTo = getReturnRouteForCurrentUser(role, location.pathname);
    return navigateTo === location.pathname
      ? <Outlet />
      : <Navigate to={navigateTo} replace />;
  }

  // If no user is logged in, redirect to login page
  return <Navigate to={`/login?returnUrl=${window.location.pathname}`} replace />;
};

export default PrivateRoute;